module.exports = __webpack_public_path__ + "static/media/pickem-home.290f3f3d.jpg";